(function ($) {

    var map;
    var allMarkers = {};
    var allInfowindows = {};
    var markerCluster;

    $(document).ready(function () {
        openMapPopin();
    });

    function openMapPopin() {
        var childrenSections = $('.section.post_preview.posts_types_hotel.posts_tpl_hotel_single .children_section');
        childrenSections.each(function () {
            var wrap = $(this),
                link = wrap.find('.view_on_map .link');

            link.click(function () {
                var overlayToOpen = '#' + $(this).closest('.item_wrap').attr('data-link');
                var contentToShow = $(overlayToOpen).html();

                $('body').append(contentToShow).hide().fadeIn(300);
                $('html').addClass('no_scroll');
                $(this).addClass('map_open');


                var hotelData;
                $.each(allHotels, function (index, key) {
                    if (key.ID == singleID) {
                        hotelData = key;
                    }
                })

                $.each(allHotels, function (index, key) {
                    if (key.lat && key.lng) {
                        create_markers(key.def_lang_ID, key.lat, key.lng);
                        create_marker_infowindow(key.def_lang_ID, key.url, key.feat_image, key.post_title, key.hotel_full_address, key.lat, key.lng);
                    }
                })

                var currentHotelMarkerObj;
                $.each(allMarkers, function (hotelID, markerData) {
                    if (hotelID == hotelData.def_lang_ID) {
                        currentHotelMarkerObj = markerData;
                    }
                });

                var currentInfoWindow;
                $.each(allInfowindows, function (hotelID, infoWindowData) {
                    if (hotelID == hotelData.def_lang_ID) {
                        currentInfoWindow = infoWindowData;
                    }
                });


                var mapWrap = $('body > .hotel_map_wrapper .hotel_map')[0];

                async function initMap() {
                    const {Map} = await google.maps.importLibrary("maps");

                    map = new Map(mapWrap, {
                        center: {lat: hotelData.lat, lng: hotelData.lng},
                        zoom: 17,
                        zoomControlOptions: {
                            position: google.maps.ControlPosition.LEFT_TOP
                        },
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        mapTypeControlOptions: {
                            position: google.maps.ControlPosition.TOP_RIGHT,
                            style: google.maps.MapTypeControlStyle.DEFAULT
                        },
                        streetViewControlOptions: {
                            position: google.maps.ControlPosition.LEFT_BOTTOM
                        },
                        fullscreenControl: false,
                    });

                    currentInfoWindow.open(map, currentHotelMarkerObj);

                    show_markers();

                    map.setOptions({styles: styleResolved});
                    map.setOptions({mapTypeId: mapType});
                    map.addListener('zoom_changed', function () {
                        clusterAccessibility();
                    });

                    //strt clustering
                    var clusterStyles = [{
                        textColor: '#000',
                        url: cluster_marker,
                        height: 50,
                        width: 48,
                        textSize: 16,
                        textLineHeight: 50,
                        className: 'cluster_group'
                    }];

                    markerCluster = new MarkerClusterer(map, allMarkers, {styles: clusterStyles});
                    markerCluster.setGridSize(70);
                }


                if (hotelData.lat && hotelData.lng) {
                    initMap();
                } else {
                    var errorMessage = '<h3 class="error_message">Hotel coordinates are missing, please enter them in the CMS hotel setup.</h3>';
                    $('body > .hotel_map_wrapper .hotel_map').append(errorMessage);
                }

                focus_and_close($(this));
                clusterAccessibility();
            });
        })
    }

    function create_markers(hotelID, latitude, longitude) {
        allMarkers[hotelID] = {};
        var image_size = new google.maps.Size(markerSizes.hotel.image_size[0], markerSizes.hotel.image_size[1]);
        var anchor = new google.maps.Point(markerSizes.hotel.anchor[0], markerSizes.hotel.anchor[1]);
        var image = {
            url: markerHotel,
            size: image_size,
            anchor: anchor
        };


        allMarkers[hotelID] = new google.maps.Marker({
            map: null,
            position: new google.maps.LatLng(latitude, longitude),
            icon: image,
        });
    }

    function show_markers() {

        $.each(allMarkers, function (hotelID, markerData) {
            thisHotelObj = $(this)[0];
            thisHotelObj.setMap(map);
            show_infowindow_on_click(hotelID, markerData);
        })
    }

    function create_marker_infowindow(hotelID, url, featImg, postTitle, fullAddress, latitude, longitude) {
        allInfowindows[hotelID] = {};


        allInfowindows[hotelID] = new google.maps.InfoWindow({
            content: `<div class="infowindow_content"><img class="infowindow_img" src="${featImg}" alt="" height="112px" width="150px"><div class="infowindow_text_box"><h4 class="infowindow_title">${postTitle}</h4><p class="infowindow_address">${fullAddress}</p><a class="link" href="${url}">${discoverHotel}</a></div></div>`,
            position: {lat: latitude, lng: longitude},
            maxWidth: 484,
            pixelOffset: new google.maps.Size(0, -4)
        })
    }

    function show_infowindow_on_click(markerID, markerObj) {
        markerObj.addListener('click', function () {
            $.each(allInfowindows, function (infoWindowID, infoWindowData) {
                infoWindowData.close();
                if (markerID == infoWindowID) {
                    infoWindowData.open(map, markerObj);

                    // Fade in infowindow
                    $('.gm-style-iw-a').hide().fadeIn(300);

                    // Center the map after timeout
                    setTimeout(function () {
                        map.panTo(markerObj.getPosition());
                    }, 300)
                }
            })
        })
    }

    function focus_and_close(current_hotel_link_btn) {
        var close = $('body > .hotel_map_wrapper .close');


        // Timeout needed to wait all map elements are loaded in dom
        setTimeout(function () {
            // Keep focus on popin elements until is open
            var focusableElements = $('body > .hotel_map_wrapper :focusable'),
                lastFocusableEl = focusableElements.last();

            $('body').keyup(function (e) {
                if (e.key == 'Tab' || e.key == 'Enter') {
                    close.focus();
                }
                $(this).off();
            });

            lastFocusableEl.keydown(function (e) {
                if (e.key == 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    close.focus();
                }
            })

            close.keydown(function (e) {
                if (e.shiftKey && e.key == 'Tab') {
                    e.preventDefault();
                    lastFocusableEl.focus();
                }
            });
        }, 2000);

        close.click(function () {
            $(this).closest('.hotel_map_wrapper').fadeOut(200, function () {
                $(this).remove();
            });
            $('html').removeClass('no_scroll');
            current_hotel_link_btn.focus();
            current_hotel_link_btn.removeClass('map_open');
            isPopinOpen = false;
        });
    }

    function clusterAccessibility() {
        setTimeout(function () {
            $('body > .hotel_map_wrapper .hotel_map .cluster > div').keydown(function (e) {
                if (e.key == 'Enter') {
                    e.preventDefault();
                    // Trigger the button element with a click
                    $(this).click();
                }
            })
        }, 1000);
    }

})(jQuery);

